import { WEBAPP_V2_URL } from 'libs/environment/useWebAppUrl'

export const REDIRECT_URL_UBBLE = `${WEBAPP_V2_URL}/verification-identite/fin`
